/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { PlatformStatus } from '../models/index';
import { PlatformStatusFromJSON, PlatformStatusToJSON } from '../models/index';

/**
 *
 */
export class PlatformStatusApi extends runtime.BaseAPI {
  /**
   * Returns comprehensive platform status including Celery tasks and active user sessions. Use this to determine if it\'s safe to deploy.
   * Get platform deployment status
   */
  async apiPlatformStatusRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PlatformStatus>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/platform-status/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PlatformStatusFromJSON(jsonValue));
  }

  /**
   * Returns comprehensive platform status including Celery tasks and active user sessions. Use this to determine if it\'s safe to deploy.
   * Get platform deployment status
   */
  async apiPlatformStatusRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlatformStatus> {
    const response = await this.apiPlatformStatusRetrieveRaw(initOverrides);
    return await response.value();
  }
}
